/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Policyholder/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Policyholder({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Payors/Content/Payors/Payor/Content/Content/Profile/InsurancePaymentAccount/Content/Content/Policyholder"
  
}) {
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let insuredInsuranceSubscriptionPersonValueData = fromData.useDataFormat({ viewPath,
context: 'insured',
path: 'insurance_subscription.person',
format: fromFormat.personName,
})
  return (<React.Fragment
>
<div
  data-testid="Policyholder.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Policyholder"
 color={dtColorsNeutral500}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="insured.insurance_subscription.person"
 format="/Data/format.js personName"
 text={insuredInsuranceSubscriptionPersonValueData}
/>
</div>
{children}
</React.Fragment>)
}